import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // Override console.log and info with a "no-op" (no operation) function
  console.log = () => {};
  console.info = () => {};
}

platformBrowserDynamic().bootstrapModule(AppModule, {preserveWhitespaces: true});
